
import * as yup from 'yup';

export const registrationSchema = yup.object({
  fullName: yup.string().required('Vui lòng nhập họ tên'),
  email: yup
    .string()
    .email('Vui lòng nhập đúng định dạng email')
    .required('Vui lòng nhập email'),
  phone: yup
    .string()
    .matches(/^[0-9]{9,11}$/, 'Số điện thoại phải từ 9-11 số')
    .required('Vui lòng nhập số điện thoại'),
  class: yup
    .string()
    .required('Vui lòng chọn lớp')
    .oneOf(
      [
        '12A1', '12A2', '12A3', '12A4', '12A5', '12A6', '12A7', '12A8',
        '12D1', '12D2', '12D3', '12D4', '12D5', '12D6',
        '12C', '12CA', '12CH', '12CL', '12CS_B', '12CT', '12CTC', '12CTin',
        '12SN1', '12SN2'
      ] as const,
      'Vui lòng chọn lớp phù hợp'
    ),
  job: yup.string().nullable(),
  workplace: yup.string().nullable(),
  additionalContribution: yup
    .number()
    .transform((value) => (isNaN(value) ? 0 : value)) // Handle non-numeric values
    .min(0, 'Giá trị không được âm')
    .max(1000000000, 'Giá trị không được vượt quá 1 tỷ đồng')
    .default(500000)
    .nullable(),
  t_shirt_size: yup.string().required('Vui lòng chọn kích thước áo'),
  gender: yup
    .string()
    .oneOf(['male', 'female'], 'Vui lòng chọn giới tính')
    .default('male')
    .required('Vui lòng chọn giới tính'),
  // Add the code property to the schema
  code: yup.string().nullable()
});

export type RegistrationFormValues = yup.InferType<typeof registrationSchema>;
